

import PlaceContest from '../../Icons/PlaceContest';
import UnlockRewards from '../../Icons/UnlockRewards';
import CircleTick from '../../Icons/CircleTick';
import MyPointContest from "../../Icons/MyPointContest";


function MemberAchievement({ contest_id, MemberAchievementDet,lang }) {

  //  const { showToast } = useToast();

    return (
        <div className="primary_light_bgcolor3 p-6 md:p-9 bg-[#F1F8FF]">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6">
                <div className="col-span-1 ">
                    <div className="bg-white p-4 rounded-md ">
                        <div className="flex justify-between items-center">
                            <p className="text-left font-normal text-sm leading-[24px] tracking-[0px] text-[#3C3C3C] opacity-100">
                                {lang?.my_points_in_contest || 'My Points in Contest'}
                            </p>
                            <div className="icons_bg bg-[#0274F7] rounded-md p-5 relative flex items-center justify-center">
                                <span className="absolute inset-0 flex items-center justify-center">
                                <MyPointContest width='20' height='20' className="text-white" />
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <h1 className="text-left font-bold text-[33px] leading-[55px] tracking-[0px] text-black opacity-100 mr-2">
                                {MemberAchievementDet?.points || "--"}
                            </h1>
                        </div>
                    </div>
                </div>

                <div className="col-span-1">
                    <div className="bg-white p-4 rounded-md">
                        <div className="flex justify-between items-center">
                            <p className="text-left font-normal text-sm leading-[24px] tracking-[0px] text-[#3C3C3C] opacity-100">
                                {lang?.my_place_in_contest || 'My Place in Contest'}
                            </p>
                            <div className="icons_bg bg-[#0274F7] rounded-md p-5 relative flex items-center justify-center">
                                <span className="absolute inset-0 flex items-center justify-center">
                                    <PlaceContest width='20' height='20' />
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <h1 className="text-left font-bold text-[33px] leading-[55px] tracking-[0px] text-black opacity-100 mr-2">
                                {MemberAchievementDet?.my_place_contest || "--"}
                            </h1>
                            <span className="primary_text_color text-left font-normal text-[13px] leading-[24px] tracking-[0px] text-[#0274F7] opacity-100">
                                 {lang?.out_of || 'out of'}  {MemberAchievementDet?.total_member}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-1">
                    <div className="bg-white p-4 rounded-md">
                        <div className="flex justify-between items-center">
                            <p className="text-left font-normal text-sm leading-[24px] tracking-[0px] text-[#3C3C3C] opacity-100">
                                 {lang?.unlock_rewards || 'Unlock Rewards'}
                            </p>
                            <div className="icons_bg bg-[#0274F7] rounded-md p-5 relative flex items-center justify-center">
                                <span className="absolute inset-0 flex items-center justify-center">
                                    <UnlockRewards width='20' height='20' />
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <h1 className="text-left font-bold text-[33px] leading-[55px] tracking-[0px] text-black opacity-100 mr-2">
                                {MemberAchievementDet?.member_reward_count || "--"}
                            </h1>
                            <span className="primary_text_color text-left font-normal text-[13px] leading-[24px] tracking-[0px] text-[#0274F7] opacity-100">
                                {lang?.out_of || 'out of'}  {MemberAchievementDet?.total_reward}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-1">
                    <div className="bg-white p-4 rounded-md">
                        <div className="flex justify-between items-center">
                            <p className="text-left font-normal text-sm leading-[24px] tracking-[0px] text-[#3C3C3C] opacity-100">
                                {lang?.entries_to_complete || 'Entries to Complete '}
                            </p>
                            <div className="icons_bg bg-[#0274F7] rounded-md p-5 relative flex items-center justify-center">
                                <span className="absolute inset-0 flex items-center justify-center">
                                    <CircleTick width='20' height='20' />
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <h1 className="text-left font-bold text-[33px] leading-[55px] tracking-[0px] text-black opacity-100 mr-2">
                                {MemberAchievementDet?.member_complete_entry || "--"}
                            </h1>
                            <span className="primary_text_color text-left font-normal text-[13px] leading-[24px] tracking-[0px] text-[#0274F7] opacity-100">
                                 {lang?.out_of || 'out of'}   {MemberAchievementDet?.total_entry}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    );
}

export default MemberAchievement;

